module.exports = __webpack_public_path__ + "static/media/tärna-min.288c41dc.png";